import React, { useState, useEffect } from 'react';

import { useAuthentication } from '../../hooks';
import { DynamicPageComponent } from './types';
import { Header } from '../Header';
import { SideBar } from '../Sidebar';
import { Routes, SIDEBAR_PIXEL_WIDTH } from '../../constants';
import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface LayoutProps {
  headerTitle: string;
  children: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
      marginLeft: SIDEBAR_PIXEL_WIDTH,
    },
  }),
);

const Layout = ({ headerTitle, children }: LayoutProps) => {
  const classes = useStyles();
  return (
    <>
      <Header title={headerTitle} />
      <SideBar routes={Routes} />
      <div className={classes.root}>
        <main className={classes.content}>{children}</main>
      </div>
    </>
  );
};

export const UserProfile: DynamicPageComponent = () => {
  const { auth } = useAuthentication();
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    if (auth.isUserSignedIn() && auth.isBasicUser()) {
      setUsername(auth.getUserName());
    }
  }, [auth]);

  return (
    <Layout headerTitle="User Profile">
      This is your profile, enjoy! Name: {username}
    </Layout>
  );
};
